<template>
	<div class="spinner">
		<div class="dot" v-for="n in 3" :key="n"></div>
	</div>
</template>

<script>
export default {
	name: "MiniSpinner"
};
</script>

<style scoped>
.spinner {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	height: 1rem;
}

.dot {
	width: 6px;
	height: 6px;
	background-color: white;
	border-radius: 50%;
	animation: bounce 1.2s infinite ease-in-out;
}

.dot:nth-child(2) {
	animation-delay: 0.2s;
}

.dot:nth-child(3) {
	animation-delay: 0.4s;
}

@keyframes bounce {
	0%, 80%, 100% {
		transform: scale(0);
		opacity: 0.3;
	}
	40% {
		transform: scale(1);
		opacity: 1;
	}
}
</style>
